  <p-toast></p-toast>
  <p-confirmDialog key="vcuPair"></p-confirmDialog>
  <app-pro-feature-modal
    [(visible)]="showVcuLimitModal"
    featureName="Adicionar mais VCUs"
    [currentPlanId]="currentPlanId"
    [billingType]="billingType"
    (planUpgraded)="onPlanUpgraded()">
  </app-pro-feature-modal>

  <div class="vcu-list-container">
    <!-- Header -->
    <div class="vcu-list-header">
      <h1>{{ 'vcuPair.list.title' | transloco }}</h1>
      <p-button
        [label]="'vcuPair.list.pairButton' | transloco"
        icon="pi pi-plus"
        severity="danger"
        [raised]="true"
        (click)="openPairDialog()"
        styleClass="pair-new-btn"
      ></p-button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="vcu-list-loading">
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
        strokeWidth="4"
        animationDuration="1s"
      ></p-progressSpinner>
      <p>{{ 'vcuPair.list.loading' | transloco }}</p>
    </div>

    <!-- Estado vazio -->
    <div *ngIf="!loading && vcus.length === 0" class="vcu-list-empty">
      <div class="empty-icon-wrapper">
        <i class="pi pi-box empty-icon"></i>
      </div>
      <h2>{{ 'vcuPair.list.emptyTitle' | transloco }}</h2>
      <p>{{ 'vcuPair.list.emptyMessage' | transloco }}</p>
      <p-button
        [label]="'vcuPair.list.emptyAction' | transloco"
        icon="pi pi-plus"
        severity="danger"
        [raised]="true"
        (click)="openPairDialog()"
        styleClass="empty-pair-btn"
      ></p-button>
    </div>

    <!-- Grid de VCUs -->
    <div *ngIf="!loading && vcus.length > 0" class="vcu-grid">
      <app-vcu-card-pair
        *ngFor="let vcu of vcus"
        [vcu]="vcu"
        (editNickname)="onEditNickname($event)"
        (unpairVcu)="onUnpairVcu($event)"
      ></app-vcu-card-pair>
    </div>
  </div>

  <!-- Seção VCUs Offline -->
  <div class="vcu-list-container offline-section">
    <div class="offline-section-header">
      <div class="offline-section-title">
        <h2>{{ 'vcu.offlineSection' | transloco }}</h2>
        <p class="offline-section-subtitle">{{ 'vcu.offlineSectionSubtitle' | transloco }}</p>
      </div>
      <p-button
        [label]="'vcu.addButton' | transloco"
        icon="pi pi-plus"
        severity="danger"
        [raised]="true"
        (click)="createVcu()"
        styleClass="pair-new-btn"
      ></p-button>
    </div>

    <div *ngIf="loadingOffline" class="vcu-list-loading">
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
        strokeWidth="4"
        animationDuration="1s"
      ></p-progressSpinner>
    </div>

    <div *ngIf="!loadingOffline && offlineVcus.length === 0" class="vcu-list-empty offline-empty">
      <div class="empty-icon-wrapper">
        <i class="pi pi-microchip empty-icon"></i>
      </div>
      <p>{{ 'vcu.emptyOffline' | transloco }}</p>
    </div>

    <div *ngIf="!loadingOffline && offlineVcus.length > 0" class="vcu-grid">
      <div *ngFor="let vcu of offlineVcus">
        <app-card-vcu [vcu]="vcu" [showUnlink]="false"></app-card-vcu>
      </div>
    </div>
  </div>

  <!-- Modal de Pareamento -->
  <app-vcu-pair-dialog
    [(visible)]="displayPairDialog"
    (dialogClosed)="onPairDialogClosed()"
  ></app-vcu-pair-dialog>

  <!-- Modal de Cadastro VCU Offline -->
  <app-register-vcu
    [showDialog]="showVcuDialog"
    (closeDialog)="updateOfflineVcuDialog()"
    [vcu]="vcuEdit"
    [editMode]="editMode">
  </app-register-vcu>
